import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { VehicleLabelDisplay } from "../models/VehicleLabelDisplay";
import { DefaultResponseWithData } from "../models/system";

export const vehicleLabelDisplayQueryKey = ["label", "vehicleDisplay"] as const;

export const vehicleLabelDisplayStaleTimeMs = 1000 * 60 * 60; // 1 hour

export default function useVehicleLabels() {
  const { get } = useApiHelper();

  const vehicleLabelDisplay = useQuery(
    vehicleLabelDisplayQueryKey,
    () =>
      get<DefaultResponseWithData<VehicleLabelDisplay>>(`/template/vehicle/label/display`),
    { staleTime: vehicleLabelDisplayStaleTimeMs }
  );

  return { vehicleLabelDisplay };
}
